import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	// ENQUANTO CARREGA, NÃO DECIDE.
	//
	// `isAuth` começa false e só vira true depois que o /auth/refresh_token
	// responde. Enquanto isso, `loading` é true e ainda não se sabe nada sobre a
	// sessão — "false" aqui significa "não sei", não "não está logado".
	//
	// Redirecionar nesse intervalo mandava para o login quem tinha sessão
	// perfeitamente válida: o usuário logava, a página recarregava (ou ele abria
	// direto numa rota privada) e era cuspido de volta para a tela de login sem
	// motivo. O mesmo valia ao contrário — quem estava na tela de login com
	// sessão válida ficava preso ali até o refresh responder.
	//
	// Esperar é a única resposta correta: as duas decisões abaixo dependem de um
	// dado que ainda não chegou.
	if (loading) {
		return <BackdropLoading />;
	}

	if (!isAuth && isPrivate) {
		return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
	}

	if (isAuth && !isPrivate) {
		return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
	}

	// `loading` já foi tratado acima; aqui ele é sempre false.
	return <RouterRoute {...rest} render={(props) => <Component {...props} />} />;
};

export default Route;
